import { SubmissionError } from 'redux-form'
import axios, { getServerErrorMessage } from '../utils/axios'
import { getPreviousEducationPeriodCd } from '../selectors/settings'
import * as c from '../constants/RefundExamConstants'
import { DEFAULT_REQUEST_ERROR } from '../constants/MessageConstants'

export const resetRefundExamFlow = () => dispatch => dispatch({ type: c.RESET_REFUND_EXAMS_FLOW })

export const fetchExamsForStudent = (orgId, id) => async (dispatch, getState) => {
  const educationPeriodCd = getPreviousEducationPeriodCd(getState())
  dispatch({ type: c.FETCH_EXAMS_FOR_STUDENT_PENDING })
  try {
    const { data } = await axios.get(
      `${Config.API_URL}/registrations/exams/organizations/${orgId}/education-periods/${educationPeriodCd}/student/${id}`
    )
    dispatch({ type: c.FETCH_EXAMS_FOR_STUDENT_FULFILLED, payload: data })
  } catch (err) {
    dispatch({ type: c.FETCH_EXAMS_FOR_STUDENT_REJECTED, payload: getServerErrorMessage(err) })
  }
}

// examsToRefund is expected to be an array of enrollmentIds to be refunded
export const submitRefundExamFlow = examsToRefund => async dispatch => {
  dispatch({ type: c.SUBMIT_REFUND_EXAMS_PENDING })
  try {
    await axios.post(`${Config.API_URL}/registrations/exams/refund`, examsToRefund)
    dispatch({ type: c.SUBMIT_REFUND_EXAMS_FULFILLED })
  } catch (err) {
    const error = getServerErrorMessage(err)
    dispatch({ type: c.SUBMIT_REFUND_EXAMS_REJECTED, payload: error })
    throw new SubmissionError(error)
  }
}

export const fetchRefundedExams = () => async dispatch => {
  dispatch({ type: c.FETCH_REFUNDED_EXAMS_PENDING })
  try {
    const { data } = await axios.get(`${Config.API_URL}/registrations/exams/refunded-registrations`)
    dispatch({ type: c.FETCH_REFUNDED_EXAMS_FULFILLED, payload: { data } })
  } catch (err) {
    const error = getServerErrorMessage(err)
    dispatch({ type: c.FETCH_REFUNDED_EXAMS_REJECTED, payload: error })
    throw new SubmissionError(error)
  }
}
